import * as React from 'react';
import Icon, { AndroidFilled, AppleFilled, GlobalOutlined } from '@ant-design/icons';
import { antBlue, antGrey } from '../components/styles/globalStyles';
import { AppPlatform } from '../types';
import { AndroidTv, TvOS, VisionOS, WearOS } from '../components/icons/iconHelpers';

export const iconForPlatform = (platform: AppPlatform, color?: string, size?: number) => {
    switch (platform) {
        case AppPlatform.TvOS:
            return <Icon component={TvOS} style={{ color: color ?? antGrey.grey6, fontSize: size }} />;
        case AppPlatform.VisionOS:
            return <Icon component={VisionOS} style={{ color: color ?? antGrey.grey6, fontSize: size }} />;
        case AppPlatform.IosSDK:
        case AppPlatform.Ios:
            return <AppleFilled style={{ color: color ?? antGrey.grey6, fontSize: size }} />;
        case AppPlatform.WearOS:
            return <Icon component={WearOS} style={{ color: color ?? antGrey.grey6, fontSize: size }} />;
        case AppPlatform.AndroidSDK:
        case AppPlatform.Android:
            return <AndroidFilled style={{ color: color ?? '#A0D911', fontSize: size }} />;
        case AppPlatform.ReactNativeOTA:
            return <GlobalOutlined style={{ color: color ?? antBlue.blue6, fontSize: size }} />;
        case AppPlatform.AndroidTV:
            return <Icon component={AndroidTv} style={{ color: color ?? antGrey.grey6, fontSize: size }} />;
        default:
            return null;
    }
};

export const iconComponentForPlatform = (platform: AppPlatform) => {
    switch (platform) {
        case AppPlatform.TvOS:
            return TvOS;
        case AppPlatform.VisionOS:
            return VisionOS;
        case AppPlatform.IosSDK:
        case AppPlatform.Ios:
            return AppleFilled;
        case AppPlatform.WearOS:
            return WearOS;
        case AppPlatform.AndroidSDK:
        case AppPlatform.Android:
            return AndroidFilled;
        case AppPlatform.AndroidTV:
            return AndroidTv;
        case AppPlatform.ReactNativeOTA:
            return GlobalOutlined;
    }
};
